import { render, staticRenderFns } from "./CatalogBlock.vue?vue&type=template&id=5d86d3c1&scoped=true&"
import script from "./CatalogBlock.vue?vue&type=script&lang=js&"
export * from "./CatalogBlock.vue?vue&type=script&lang=js&"
import style0 from "./CatalogBlock.vue?vue&type=style&index=0&id=5d86d3c1&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d86d3c1",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {UiSpinner: require('/app/components/UI/UiSpinner.vue').default,UiPagination: require('/app/components/UI/UiPagination.vue').default,SeoPagination: require('/app/components/seo/SeoPagination.vue').default})
